module.exports = __webpack_public_path__ + "static/img/sggs_img_3.b134ae9a.png";